import { mapDTOToCustomWorklist, type CustomWorklist, type CustomWorklistDTO } from '@/Models/GenericWorklist/CustomWorklist';

export interface CustomWorklistSaveResultDTO {
    SavedWorklistID: number;
    Worklists: CustomWorklistDTO[];
}

export interface CustomWorklistSaveResult {
    SavedWorklistID: number;
    Worklists: CustomWorklist[];
}

export const mapDTOToCustomWorklistSaveResult = (dto: CustomWorklistSaveResultDTO): CustomWorklistSaveResult => {
    const { Worklists: customWorklistDTOs } = dto;

    const customWorklists = customWorklistDTOs.map((customWorklistDTO) => mapDTOToCustomWorklist(customWorklistDTO));
    return {
        ...dto,
        Worklists: customWorklists,
    };
};
